<template>
  <div class="row justify-content-center g-4">
    <div
      v-for="(item) in propertyData.slice(0, 6)"
      :key="item.id"
      class="col-xl-4 col-lg-4 col-md-6 col-sm-12"
    >
      <GridLayout :item="item" :border="true" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
// import { propertyData } from '@/data/data';
import GridLayout from "./grid-layout.vue";
// import { useStore } from "vuex";

// const store = useStore();
// const { propertyData } = await store.getters["properties/properties"];

// if (this.$store.getters["properties/properties"].length == 0) {
//     await this.$store.dispatch("properties/loadPropertiesfirebaseAdmin");
//   }

defineProps({
  border: Boolean,
  propertyData: {
    type: Array,
    required: true,
  },
});
onMounted(async () => {});
</script>
